const sizeUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB']
const binarySizeUnits = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB']
const frequencyUnits = ['Hz', 'kHz', 'MHz', 'GHz', 'THz']

const formatMeasurement = (
  value: number | null | undefined,
  unit: string | null | undefined,
  units: string[],
  base: number,
) => {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) return '-'

  const sourceUnit = unit?.trim() || ''
  let index = units.findIndex((item) => item.toLowerCase() === sourceUnit.toLowerCase())
  // Preserve unknown units instead of guessing their magnitude.
  if (index < 0) return `${value}${sourceUnit ? ` ${sourceUnit}` : ''}`

  let converted = value
  while (converted >= base && index < units.length - 1) {
    converted /= base
    index += 1
  }
  while (converted > 0 && converted < 1 && index > 0) {
    converted *= base
    index -= 1
  }
  return `${Number(converted.toFixed(2))} ${units[index]}`
}

export const formatHardwareSize = (value?: number | null, unit?: string | null) => {
  const sourceUnit = /^(bytes?|b)$/i.test(unit?.trim() || '') ? 'B' : unit
  const binary = binarySizeUnits.slice(1).some((item) => item.toLowerCase() === sourceUnit?.trim().toLowerCase())
  return formatMeasurement(value, sourceUnit, binary ? binarySizeUnits : sizeUnits, binary ? 1024 : 1000)
}

export const formatHardwareFrequency = (value?: number | null, unit?: string | null) => (
  formatMeasurement(value, unit, frequencyUnits, 1000)
)
